export const thStyle = {
    backgroundColor: '#241815', color: '#ff6a3d', fontSize: 11, fontWeight: 700,
    letterSpacing: '0.08em', textTransform: 'uppercase' as const,
    whiteSpace: 'nowrap' as const, py: 1.5, borderBottom: '1px solid #2a2a2a !important',
    position: 'sticky' as const, top: 0, zIndex: 2,
}
export const tdStyle = { color: '#c0c0c0', py: 1.4, fontSize: 13, whiteSpace: 'nowrap' as const }
export const trHover = { transition: 'background 0.15s', '&:hover': { background: '#ff6a3d08' } }
export const tableSx = { '& .MuiTableCell-root': { borderBottom: '1px solid #1e1e1e' } }

export const searchFieldStyle = {
    background: 'transparent', borderRadius: '7px',
    border: '1px solid #898989', transition: 'border-color 0.3s',
    '&:hover': { border: '1px solid #ff6a3d' },
    '&:focus-within': { border: '1px solid #ff6a3d' },
    '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
    '& input': { color: '#fff', fontSize: 13 },
    '& input::placeholder': { color: '#555', opacity: 1 },
}

export const paginationStyle = {
    color: '#6a6a6a', borderTop: '1px solid #252525',
    '& .MuiTablePagination-toolbar': { justifyContent: 'center' },
    '& .MuiTablePagination-selectLabel': { color: '#6a6a6a', margin: 0 },
    '& .MuiTablePagination-displayedRows': { color: '#6a6a6a', margin: 0 },
    '& .MuiSelect-select': { color: '#6a6a6a' },
    '& .MuiSelect-icon': { color: '#6a6a6a' },
    '& .MuiIconButton-root': { color: '#6a6a6a' },
    '& .MuiIconButton-root.Mui-disabled': { color: '#333' },
}

/** Labelled dark text field (compose form, dialogs). */
export const formFieldSx = {
    '& .MuiOutlinedInput-root': {
        borderRadius: '10px', color: '#fff', background: '#1a1a1a',
        '& fieldset': { borderColor: '#333' },
        '&:hover fieldset': { borderColor: '#ff6a3d80' },
        '&.Mui-focused fieldset': { borderColor: '#ff6a3d' },
    },
    '& .MuiInputLabel-root': { color: '#7a7a7a', fontSize: 13 },
    '& .MuiInputLabel-root.Mui-focused': { color: '#ff6a3d' },
    '& input, & textarea': { color: '#fff', fontSize: 13 },
    '& input::placeholder, & textarea::placeholder': { color: '#555', opacity: 1 },
    '& .MuiFormHelperText-root': { color: '#6a6a6a', fontSize: 11, marginLeft: 0 },
    '& .MuiFormHelperText-root.Mui-error': { color: '#ef4444' },
    '& .MuiSelect-icon': { color: '#898989' },
    '& .Mui-disabled': { WebkitTextFillColor: '#555' },
}

export const menuPaperSx = {
    background: '#141414', color: '#fff', border: '1px solid #333',
    '& .MuiMenuItem-root': { fontSize: 13, '&:hover': { bgcolor: '#241815' } },
    '& .MuiMenuItem-root.Mui-selected': { bgcolor: '#241815' },
    '& .MuiAutocomplete-option': { fontSize: 13, '&:hover': { bgcolor: '#241815' }, "&[aria-selected='true']": { bgcolor: '#241815' } },
    '& .MuiAutocomplete-noOptions, & .MuiAutocomplete-loading': { color: '#7a7a7a', fontSize: 13 },
    '& .MuiAutocomplete-groupLabel': { background: '#1a1a1a', color: '#ff6a3d', fontSize: 11 },
}

export const selectProps = { MenuProps: { slotProps: { paper: { sx: menuPaperSx } } } }

export const checkboxSx = {
    color: '#898989', padding: '6px',
    '&.Mui-checked': { color: '#ff6a3d' },
    '&.MuiCheckbox-indeterminate': { color: '#ff6a3d' },
}

export const panelTitleSx = { fontSize: 14, fontWeight: 700, color: '#e0e0e0' }
export const subLabelSx = { fontSize: 11, color: '#6a6a6a', letterSpacing: '0.08em', textTransform: 'uppercase' as const, mb: 1 }

export const primaryBtnSx = {
    fontSize: 12, fontWeight: 700, borderRadius: '7px', textTransform: 'none' as const,
    color: '#fff', background: 'linear-gradient(135deg, #f2674a, #d94f35)', px: 2, py: 1,
    boxShadow: '0 4px 16px rgba(242,103,74,.3)',
    '&:hover': { filter: 'brightness(0.92)' },
    '&.Mui-disabled': { opacity: 0.45, color: '#fff' },
}
export const outlineBtnSx = {
    fontSize: 12, fontWeight: 700, borderRadius: '7px', textTransform: 'none' as const,
    color: '#ff6a3d', border: '1px solid #ff6a3d40', background: '#ff6a3d10', px: 1.5, py: 1, minWidth: 80,
    '&:hover': { background: '#ff6a3d20', borderColor: '#ff6a3d' },
    '&.Mui-disabled': { opacity: 0.4, color: '#ff6a3d' },
}
export const dangerBtnSx = {
    ...outlineBtnSx, color: '#ef4444', border: '1px solid #ef444440', background: '#ef444410',
    '&:hover': { background: '#ef444420', borderColor: '#ef4444' },
    '&.Mui-disabled': { opacity: 0.4, color: '#ef4444' },
}
// Buttons that sit on the orange page-header gradient
export const headerBtnSx = {
    fontSize: 12, fontWeight: 700, borderRadius: '8px', textTransform: 'none' as const,
    color: '#fff', border: '1px solid rgba(255,255,255,0.5)', background: 'rgba(255,255,255,0.12)', px: 1.8, py: 0.8,
    '&:hover': { background: 'rgba(255,255,255,0.25)', borderColor: '#fff' },
    '&.Mui-disabled': { opacity: 0.5, color: '#fff' },
}
export const cancelBtnSx = {
    border: '1px solid #333', borderRadius: '10px', color: '#7a7a7a', fontWeight: 600, textTransform: 'none' as const,
    '&:hover': { borderColor: '#555', color: '#fff', background: 'transparent' },
}
export const dialogPaperSx = {
    backgroundColor: '#242424', borderRadius: '16px', border: '1px solid #333', overflow: 'hidden',
    boxShadow: '0 0 60px rgba(242,103,74,.2)',
}
export const dialogTitleSx = {
    background: 'linear-gradient(135deg, #f2674a, #d94f35)', color: '#fff',
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    fontWeight: 700, fontSize: 15, boxShadow: '0 4px 20px rgba(242,103,74,.35)',
}
export const dialogContentSx = { backgroundColor: '#242424', pt: '20px !important' }
export const mutedText = { color: '#7a7a7a', fontSize: 12 }
